import React from 'react';

export default function Badge({
  tagClass,
  tagContent,
  upperCase = true,
}: {
  tagClass: string;
  tagContent: string;
  upperCase?: boolean;
}) {
  return (
    <div
      className={`flex font-rp-pn-semi-bold items-center justify-center px-1 pb-1 pt-1.5 rounded h-4.5 text-sm tracking-0.3 w-fit ${tagClass} ${
        upperCase ? 'uppercase' : ''
      }`}
    >
      {tagContent}
    </div>
  );
}
